import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { isSignInWithEmailLink } from 'firebase/auth';
import { auth } from '../../../api/firebase/config';
import { firebaseActionMode } from '../../../constants/enum';
import { throwError } from '../../../modules/error';
import CustomLoading from '../../uiParts/form/CustomLoading';
import Header from '../../uiParts/menu/Header';
import MetaTitle from '../../utils/MetaTitle';

const Action: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(window.location.search);
  const oobCode = queryParams.get('oobCode') ?? '';
  const mode = queryParams.get('mode') ?? '';

  const isLoggined = useMemo(() => {
    const currentUrl = window.location.href;
    return isSignInWithEmailLink(auth, currentUrl);
  }, []);

  useEffect(() => {
    setLoading(true);
    try {
      if (isLoggined) {
        const currentUrl = window.location.href;
        const decodeUrl = new URL(decodeURIComponent(currentUrl));
        const params = decodeUrl.searchParams;
        const continueUrl = params.get('continueUrl');

        if (continueUrl) {
          const url = new URL(continueUrl);
          const secondParams = url.searchParams;
          const email = secondParams.get('email')?.split('?').join('') ?? '';

          if (currentUrl.includes('register')) {
            navigate(`/staff/register?oobCode=${oobCode}&email=${email}&anchor=login`);
          }
        }
      } else if (mode === firebaseActionMode.revertSecondFactorAddition) {
        // 二段階認証の登録取り消し（#3300）。パスワード再設定とは oobCode の種類が
        // 異なるため、既定の password_change に流すと検証に失敗する
        navigate(`/auth/mfa_revert?oobCode=${oobCode}`);
      } else {
        navigate(`/auth/password_change?oobCode=${oobCode}`);
      }
    } catch (e) {
      throwError(e);
    } finally {
      setLoading(false);
    }
  }, [isLoggined, mode, navigate, oobCode]);

  return (
    <>
      <MetaTitle />
      <CustomLoading loading={loading} />
      <Header />
    </>
  );
};

export default Action;
